import _ from "lodash";

export default _.mapKeys([
	"LOGIN_USER",
	"LOGOUT_USER",
	"AUTHENTICATE_USER",
	"UPDATE_USER",

	"UPDATE_LAYOUT_PROPS",
	"FETCH_PAGES_REQUEST",
	"FETCH_PAGES_FAILURE",
	"SET_ALL_PAGES",
	"SET_FILTERED_PAGES",
	"FETCH_PAGE_REQUEST",
	"FETCH_PAGE_FAILURE",
	"SET_PAGE",
	"FETCH_PUBLISHABLE_PAGES_REQUEST",
	"FETCH_PUBLISHABLE_PAGES_FAILURE",
	"SET_ALL_PUBLISHABLE_PAGES",
	"SET_FILTERED_PUBLISHABLE_PAGES",
	"UPDATE_COMPONENT_INSTANCE_IN_PAGE",
	"SET_SECONDARY_HEADER",
	"SET_JSON_FORM_CUSTOM_COMPONENT",
	"RESET_JSON_FORM_CUSTOM_COMPONENTS",
	"UPDATE_PAGE_DATA",
	"SET_LAYOUTS",
	"SET_BACKEND_ERROR_MESSAGE",
	"SET_CURRENT_TENANT",
	"GENERATE_NEW_SESSION_ID",
	"SET_VALIDATION_ERROR",
	"UPDATE_SPRITE_CSS",
	"SET_SPRITE_IMAGE",

	"SET_USER_FEATURE",
	"SET_ALL_ROLES",

	//
	"UPDATE_FULL_PAGE_DATA",
	"SET_ALL_PAGE_VERSIONS",

	//Configs
	"FETCH_CONFIGS",
	"FETCH_CONFIGS_SUCCESS",
	"FETCH_CONFIGS_FAILURE",
	"SET_CURRENT_CONFIG",
	"PUBLISH_CONFIG_SUCCESS",
	"PUBLISH_CONFIGS_SUCCESS",
	"UPDATE_CURRENT_CONFIG_SUCCESS",
	"REVERT_CURRENT_CONFIG_SUCCESS",

	// Entities
	"FETCH_PROGRAM_PACKAGES",
	"FETCH_PROGRAM_PACKAGES_SUCCESS",
	"FETCH_PROGRAM_PACKAGES_FAILURE",

	// Program Launcher
	"SET_LOADER_STATUS",
	"SET_CURRENT_STEP",
	"SET_ALL_STEPS_STATUSES",
	"SET_STEP_STATUS",
	"SET_CURRENT_PROGRAM",
	"CLEAR_PROGRAM_DATA",

	// Application Journeys
	"SET_DEFAULT_STEP_TEMPLATES",
	"SET_SELECTED_STEP",
	"SET_DEFAULT_FORM_ITEM_TEMPLATES",
	"SET_SELECTED_FORM_ITEM",
	"SET_CONFIG_STATUS",
	"SET_APPLICATION_FLOW_TYPE",
	"SET_JOURNEY_ENTITY_STATUS",
	"SET_DEFAULT_MANUAL_PROCESS_FIELD_TEMPLATES",
	"SET_MANUAL_FIELD_TEMPLATE_PREFERENCE",
	"SET_SELECTED_SECTION_ITEM",

	// Offline Payments
	"SET_FILE_UPLOAD_TIMESTAMP",

	// Bulk Deferral Upload
	"SET_DEFERRAL_FILE_UPLOAD_TIMESTAMP",
	"SET_FEE_FILE_UPLOAD_TIMESTAMP",

	// Coupon payment gateway
	"SET_DISCOUNT_PAYMENT_GATEWAY_MODE_UPLOAD_TIMESTAMP",
]);
